module.exports = __webpack_public_path__ + "static/media/stubhub.a0676241.svg";